/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBrandCampaignmonitor = createReactComponent(
  "brand-campaignmonitor",
  "IconBrandCampaignmonitor",
  [
    [
      "path",
      { d: "M3 18l9 -6.462l-9 -5.538v12h18v-12l-9 5.538", key: "svg-0" }
    ]
  ]
);

export { IconBrandCampaignmonitor as default };
//# sourceMappingURL=IconBrandCampaignmonitor.js.map
